module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['block-monkey', _vm.container_class],
    style: ({
      'background-image': 'url( ' + _vm.image + ' )'
    })
  }, [_c('div', {
    class: ['row-elements', _vm.sub_class]
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), (_vm.link_label) ? _c('a', {
    staticClass: "btn default",
    attrs: {
      "href": _vm.link_url
    }
  }, [_vm._v(_vm._s(_vm.link_label))]) : _vm._e(), _vm._v(" "), (_vm.extra_link_label) ? _c('a', {
    staticClass: "btn default",
    attrs: {
      "href": _vm.extra_link_url
    }
  }, [_vm._v(_vm._s(_vm.extra_link_label))]) : _vm._e(), _vm._v(" "), (_vm.button_video_true) ? _c('button', {
    staticClass: "btn default show-modal",
    attrs: {
      "id": "show-modal"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.video_button_title)
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "videoWrapper"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.videosrc,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-caption"
  }, [_c('em', [_vm._v(_vm._s(_vm.image_caption))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2010d76e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlockMonkey.vue
// module id = 317
// module chunks = 0